import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { formSettings } from './../settings';
import { FormattedMessage } from 'react-intl';
import { RadioField } from './../../../../../../components/fields';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { getI9DocumentsIntroText, renderOptions, getDocumentDetails } from './assets/i9DocType';
import { setProgressionProperties } from '../../../../../../reducers/onboarding';
import { updateUserProfile } from '../../../../../../reducers/identity';
import { createI9Form } from '../../../../../../reducers/documents';
import { updateI9, submitI9 } from '../../../../../../reducers/i9s';
import { getProps } from '../../../../../../utilities/common';
import { getLatestOpenI9 } from '../../../../../../reducers/i9s';
import I9 from '../../../../../../models/i9';
import User from '../../../../../../models/user';
import { dateToFloatingString, fixDate } from '../../../../../../utilities/dateTime';
import { maskSSN } from '../../../../../../utilities/string';
import mixpanel from 'mixpanel-browser';
class I9DocumentsStep extends React.Component {
    constructor(props) {
        super(props);

        this.areRequirementsMet = this.areRequirementsMet.bind(this);
        this.submit = this.submit.bind(this);
        this.renderI9form2 = this.renderI9form2.bind(this);
        this.renderListA = this.renderListA.bind(this);
        this.renderListBC = this.renderListBC.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'I9DocumentsStep' } });

        const { profile, setProgressionProperties, getLatestOpenI9, i9 } = this.props;

        let personalInformation = {
            firstName: profile.first_name,
            middleName: profile.middle_name,
            lastName: profile.last_name,
            email: profile.email,
            phoneNumber: profile.phone,
            dateOfBirth: profile.birthday_date,
            socialSecurityNumber: maskSSN(profile.ssn_bg_check),
            emergency_name: profile.emergency_name,
            emergency_email: profile.emergency_email,
            emergency_phone: profile.emergency_phone,
            emergency_relationship: profile.emergency_relationship,
            w4_fields: profile.w4_fields,
            i9_fields: { docsType: 'A', ...profile.i9_fields }
        };

        let dateOfBirth = { day: null, month: null, year: null };
        if (personalInformation.dateOfBirth) {
            let date = new Date(personalInformation.dateOfBirth + 'T00:00:00');
            dateOfBirth = {
                date: personalInformation.dateOfBirth,
                day: isNaN(date.getDate()) ? null : date.getDate(),
                month: isNaN(date.getMonth()) ? null : date.getMonth() + 1,
                year: isNaN(date.getFullYear()) ? null : date.getFullYear()
            };
        }

        if (!i9) getLatestOpenI9(profile.id);

        setProgressionProperties({ personalInformation: { ...personalInformation, dateOfBirth } });
    }

    submit(values, action) {
        const {
            profile,
            updateUserProfile,
            updateI9,
            submitI9,
            progression,
            setProgressionProperties,
            documents,
            createI9Form,
            details,
            admin,
            i9
        } = this.props;

        const { i9_fields } = values;
        const { listAChoice, listBChoice, listCChoice } = i9_fields;
        let docsType = i9_fields.docsType ? i9_fields.docsType : 'A';

        const { A, B, C } = i9_fields;
        const adjustDate = obj => {
            if (obj && obj.expDate) obj.expDate = dateToFloatingString(fixDate(obj.expDate), 'MM-DD-YYYY');
        };
        adjustDate(A);
        adjustDate(B);
        adjustDate(C);

        const data = new User({ ...profile, i9_fields });
        updateUserProfile(data, async () => {
            const i9obj = new I9({ id: i9.id, worker_i9_fields: i9_fields });
            updateI9(i9obj, async () => {
                setProgressionProperties({
                    personalInformation: { ...progression.personalInformation, i9_fields }
                });

                const document_ids =
                    docsType === 'A'
                        ? [documents[`i9-A-${listAChoice}`].list[0].id]
                        : [documents[`i9-B-${listBChoice}`].list[0].id, documents[`i9-C-${listCChoice}`].list[0].id];

                createI9Form(profile.id, details.id, admin.id, docsType === 'A' ? 'A' : 'BC', { document_ids }, () => {
                    submitI9(i9.id, action);
                });
            });
        });
    }

    areRequirementsMet() {
        const { i9_fields, documents } = this.props;
        if (!i9_fields) {
            return false;
        }

        const validate = (definition, choice, literal) => {
            let isChoiceValid = getProps(definition).includes(choice);
            let docListPresent = Object.keys(documents).includes(`i9-${literal}-${choice}`);
            let docProp = documents[`i9-${literal}-${choice}`];
            let docUploaded = docProp && docProp.list && docProp.list.length > 0;
            const result = isChoiceValid && docListPresent && docUploaded;
            return result;
        };

        const { docsType, listAChoice, listBChoice, listCChoice } = i9_fields;
        const { A, B, C } = getDocumentDetails();

        switch (docsType) {
            case 'A':
                return validate(A.map(i => i.doc.docType), listAChoice, 'A');

            case 'BC':
                return validate(B.map(i => i.doc.docType), listBChoice, 'B') && validate(C.map(i => i.doc.docType), listCChoice, 'C');

            default:
                return false;
        }
    }

    renderListA() {
        const { i9_fields } = this.props;
        if (!i9_fields) {
            return null;
        }
        const { listAChoice } = i9_fields;
        return (
            <div className="row">
                <div className="col-xs-12">
                    <FormattedMessage
                        id={'i9Docs.A.intro1'}
                        defaultMessage={'List A: Identity and Employment Authorization Documents (select one)'}
                        tagName={'h5'}
                    />
                </div>
                <div className="col-xs-12 i9-docs-list-abc">
                    <Field name="i9_fields.listAChoice" component={RadioField} options={renderOptions(listAChoice, 'A', i9_fields)} />
                </div>
            </div>
        );
    }

    renderListBC() {
        const { i9_fields } = this.props;
        if (!i9_fields) {
            return null;
        }
        const { listBChoice, listCChoice } = i9_fields;
        return (
            <div className="row">
                <div className="col-xs-12 col-sm-6 group">
                    <FormattedMessage id={'i9Docs.B.intro1'} defaultMessage={'List B: Identity Documents (select one)'} tagName={'h5'} />
                    <div className="i9-docs-list-abc">
                        <Field name="i9_fields.listBChoice" component={RadioField} options={renderOptions(listBChoice, 'B', i9_fields)} />
                    </div>
                </div>
                <div className="col-xs-12 col-sm-6 group">
                    <FormattedMessage id={'i9Docs.C.intro1'} defaultMessage={'List C: Employment Authorization (select one)'} tagName={'h5'} />
                    <div className="i9-docs-list-abc">
                        <Field name="i9_fields.listCChoice" component={RadioField} options={renderOptions(listCChoice, 'C', i9_fields)} />
                    </div>
                </div>
            </div>
        );
    }

    renderI9form2() {
        const { handleSubmit, onSubmit, back, submitting, i9_fields } = this.props;
        if (!i9_fields) return null;
        const { docsType } = i9_fields;
        if (!docsType) return null;

        const docsChoices = [
            {
                value: 'A',
                label: (
                    <div className={`docs-option ${docsType === 'A' ? 'active' : ''}`}>
                        <FormattedMessage id={'i9Docs.listA'} defaultMessage={'LIST A'} />
                    </div>
                )
            },
            {
                value: 'BC',
                label: (
                    <div className={`docs-option ${docsType === 'BC' ? 'active' : ''}`}>
                        <FormattedMessage id={'i9Docs.listBC'} defaultMessage={'LIST B and C'} />
                    </div>
                )
            }
        ];

        return (
            <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                <div className="row">
                    <div className="col-xs-12 doc-choices-wrapper">
                        <Field name="i9_fields.docsType" component={RadioField} options={docsChoices} />
                    </div>
                </div>
                {docsType === 'BC' ? this.renderListBC() : this.renderListA()}
                <WizardButtons disabled={submitting || !this.areRequirementsMet()} back={{ action: back }} />
            </form>
        );
    }

    render() {
        const { i9 } = this.props;
        return (
            <div>
                {getI9DocumentsIntroText()}
                {i9 && this.renderI9form2()}
            </div>
        );
    }
}

I9DocumentsStep = reduxForm(formSettings)(I9DocumentsStep);

const mapStateToProps = state => {
    const selector = formValueSelector(formSettings.form);
    let progression = state.onboarding.progression;
    let existingI9Info =
        progression && progression.personalInformation && progression.personalInformation.i9_fields && progression.personalInformation.i9_fields.docsType
            ? progression.personalInformation.i9_fields
            : {};
    let initialValues = { i9_fields: { docsType: 'A', ...existingI9Info } };

    return {
        role: state.identity.role,
        job: state.onboarding.job,
        profile: state.identity.profile,
        details: state.identity.details,
        admin: state.onboarding.admin,
        progression,
        i9: state.i9s.i9,
        i9_fields: { docsType: 'A', ...selector(state, 'i9_fields') },
        additionalFields: {
            A: selector(state, 'i9_fields.A'),
            B: selector(state, 'i9_fields.B'),
            C: selector(state, 'i9_fields.C')
        },
        documents: state.documents,
        initialValues
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            updateUserProfile,
            updateI9,
            submitI9,
            getLatestOpenI9,
            createI9Form,
            setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(I9DocumentsStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/i9Documents.jsx